import Box from '~/ui/components/Box/Box';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';

export const sizes = {
  s: {
    knobRadius: '7px',
    p: '3px',
    width: '40px',
  },
  m: {
    knobRadius: '10px',
    p: 1,
    width: '48px',
  },
} as const;

export type SwitchSize = keyof typeof sizes;

export const styles = {
  default: {
    onBg: 'green-500',
    offBg: 'gray-400',
  },
  danger: {
    onBg: 'red-600',
    offBg: 'gray-400',
  },
} as const;

export type SwitchVariant = keyof typeof styles;

export type SwitchProps = {
  disabled?: boolean;
  id?: string;
  size?: SwitchSize;
  value?: boolean;
  variant?: SwitchVariant;
  onChange?: (value: boolean) => void;
};

function Switch({
  disabled,
  id,
  size = 'm',
  value = false,
  variant = 'default',
  onChange,
}: SwitchProps) {
  const { knobRadius, p, width } = sizes[size];
  const variantStyle = styles[variant] ?? styles.default;

  return (
    <FlexLayout
      role="switch"
      alignItems="center"
      disabled={disabled}
      justifyContent={value ? 'flex-end' : 'flex-start'}
      id={id}
      p={p}
      sx={{
        bg: `${value ? variantStyle.onBg : variantStyle.offBg}`,
        borderRadius: 'pill',
        width,
      }}
      onClick={() => onChange?.(!value)}
    >
      <Box
        className="ui/switch__knob"
        p={knobRadius}
        sx={{
          bg: 'white',
          borderRadius: 'round',
        }}
      />
    </FlexLayout>
  );
}

export default Switch;
